export default {
      id: "check-out-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite.svg#check-out",
      toString: function () {
        return this.url;
      }
    }